<template>
  <b-tabs>
    <b-tab-item>
      <template #header>
        <span>
          {{ $t('compTransitionReviewerMain.tab-to-review') }}
          <b-tag rounded> {{ counts.reviewable }} </b-tag>
        </span>
      </template>
      <review-actions></review-actions>
    </b-tab-item>
    <b-tab-item>
      <template #header>
        <span>
          {{ $t('compTransitionReviewerMain.tab-reminder') }}
          <b-tag rounded> {{ counts.reminded_late }} </b-tag>
        </span>
      </template>
      <review-reminder></review-reminder>
    </b-tab-item>
    <b-tab-item :label="$t('compTransitionReviewerMain.tab-all-actions')">
      <review-published></review-published>
    </b-tab-item>
  </b-tabs>
</template>

<script>
import transitionService from '@/services/transitionService'

export default {
  name: 'Transition1point5Review',
  data: function () {
    return {
      counts: {
        reviewable: 0,
        reminded: 0,
        published: 0
      }
    }
  },
  components: {
    'review-actions': () => import('./ReviewActions.vue'),
    'review-published': () => import('./ReviewPublished.vue'),
    'review-reminder': () => import('./ReviewReminder.vue')
  },
  mounted () {
    transitionService.reviewerGetCounts().then((data) => (this.counts = data))
  }
}
</script>
